var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraineeAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47.9999756px",
    height: "48px",
    viewBox: "0 0 47.9999756 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user_avatar_icon@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TraineeTile",
    transform: "translate(-16.000000, -16.000000)",
    fill: "#5C0F8B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_avatar_icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    cx: 23.9999878,
    cy: 23.9999878,
    r: 23.9999878
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.731791, 6.967738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5277998,31.3353131 C33.9893827,25.2592241 26.8508612,21.6797817 19.2669255,21.6774032 C11.6829898,21.675027 4.5422255,25.2499932 0,31.3232357 C4.51970413,37.4280584 11.6650318,41.0298793 19.2608583,41.0322616 C26.8566847,41.0346415 34.0042691,37.437301 38.5277998,31.3353131 L38.5277998,31.3353131 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.2681967,
    cy: 9.29031786,
    r: 9.29031786
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraineeAvatar);
export default __webpack_public_path__ + "static/media/traineeAvatar.de2bf4d81771e039be180202881df9a9.svg";
export { ForwardRef as ReactComponent };